import {useEffect, useState} from 'react';
import useAxios from 'hooks/useAxios';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import SlideItem from './SlideItem';
import {config} from 'config';
import eventImage from "../../../assets/images/eventImageNow.jpeg";
import banner2 from "../../../assets/images/banners-bienestar.png";
import wellbeingWeekImage from "../../../assets/images/SemanadelBienestarBanner.png";
import eventImageEsp from "../../../assets/images/Banner_proposito.jpg";
import eventImageEng from "../../../assets/images/slide-eng.jpg";
import eventImageOctEsp from "../../../assets/images/Banner_semana_bienestar.png";
import eventImageOctEng from "../../../assets/images/Banner_semana_bienestar.png";
import secondBannerImage from "../../../assets/images/banner_bienestar_op2.png";
import wellbeing2026Esp from "../../../assets/images/wellbeing_2026-slide-esp.png";
import wellbeing2026Eng from "../../../assets/images/wellbeing_2026-slide-eng.png";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {AppContext} from '../../../contexts/AppContext';
import {useContext} from 'react';

const SliderFull = ({category_id, category_name_for_show, header = false, specialRegister = false}) => {

    const [posterItems, setPosterItems] = useState([]);
    const [wellbeingWeek, setWellbeingWeek] = useState(false)
    const [eventlang, setEventlang] = useState(true)
    const [firtBanner, setFirtBanner] = useState(false)
    const [firstImageBanner, setFirstImageBanner] = useState(eventImageOctEsp)
    const [secondImageBanner, setSecondImageBanner] = useState(secondBannerImage)
    const [eventImageLang, setEventImageLang] = useState(eventImageEsp)
    const [wellbeing2026Banner, setWellbeing2026Banner] = useState(wellbeing2026Esp)

    const event = false
    const secondBanner = false

    const dataLang = useContext(AppContext)
    console.log(dataLang)

    const {response, loading, error} = useAxios({
        // aos-category/parent_id/8e6c242d4ca841409c68a1e4079ba4ad
        method: 'get',
        url: `aos-vod/category/${category_id}?tenant_id=tecmilenio&category_id=${category_id}`
    });

    useEffect(() => {
        if (response !== null) {
            let list = []
            for (const video of response.category_list) {
                if (video.public_see === 1) {
                    list.push(video)
                }
            }
            setPosterItems(list);
        }
    }, [response]);

    useEffect(() => {
        if (dataLang.langSpanish) {
            setFirstImageBanner(eventImageOctEsp);
            setWellbeing2026Banner(wellbeing2026Esp);
        } else {
            setFirstImageBanner(eventImageOctEng)
            setWellbeing2026Banner(wellbeing2026Eng)
        }

    }, [dataLang]);

    const Slider = () => {
        const HOME_VIDEO_ID = 'ebba4c5995454cee9edcbabdd255bc61';
        const SPECIAL_VIDEO_ID = '8f6ab1d4fc4646d3b2c6bbb2642ff753';

        let firstVideoSlide = null;
        let secondVideoSlide = null;
        let otherSlides = [];

        if (specialRegister) {
            const homeVideoIndex = posterItems.findIndex(poster => poster.stream_id === HOME_VIDEO_ID || poster.asset_id === HOME_VIDEO_ID);
            const specialVideoIndex = posterItems.findIndex(poster => poster.stream_id === SPECIAL_VIDEO_ID || poster.asset_id === SPECIAL_VIDEO_ID);

            if (homeVideoIndex !== -1) {
                firstVideoSlide = <SlideItem key={posterItems[homeVideoIndex].asset_id} {...posterItems[homeVideoIndex]} category_name_for_show={category_name_for_show} specialRegister={specialRegister}/>;
            }
            if (specialVideoIndex !== -1) {
                secondVideoSlide = <SlideItem key={posterItems[specialVideoIndex].asset_id} {...posterItems[specialVideoIndex]} category_name_for_show={category_name_for_show} specialRegister={specialRegister}/>;
            }

            otherSlides = posterItems.filter((_, index) => index !== homeVideoIndex && index !== specialVideoIndex).map((poster) =>
                <SlideItem key={poster.asset_id} {...poster} category_name_for_show={category_name_for_show} specialRegister={specialRegister}/>
            );
        } else {
            const homeVideoIndex = posterItems.findIndex(poster => poster.stream_id === HOME_VIDEO_ID || poster.asset_id === HOME_VIDEO_ID);
            
            if (homeVideoIndex !== -1) {
                firstVideoSlide = <SlideItem key={posterItems[homeVideoIndex].asset_id} {...posterItems[homeVideoIndex]} category_name_for_show={category_name_for_show} specialRegister={specialRegister}/>;
            }

            otherSlides = posterItems.filter((_, index) => index !== homeVideoIndex).map((poster) =>
                <SlideItem key={poster.asset_id} {...poster} category_name_for_show={category_name_for_show} specialRegister={specialRegister}/>
            );
        }

        return (
            <OwlCarousel className='owl-carousel owl-loaded owl-drag' {...config.owlCarousel.full_slider.options}>
                {/* {!specialRegister && (
                    <div className="item" style={{backgroundImage: `url(${wellbeing2026Banner})`}}>
                        <div className="gen-movie-contain h-100">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-xl-6">
                                        <div className="gen-tag-line"><span></span></div>
                                        <div className="gen-movie-action">
                                            <div className="gen-btn-container button-1">
                                                <Link to="/organizaciones-con-proposito" className="gen-button">
                                                    <span className="text">
                                                        <FormattedMessage
                                                            id="buttonLearnmore"
                                                            defaultMessage="Ver Ahora"
                                                        />
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )} */}
              {firstVideoSlide}
              {secondVideoSlide}
              {firtBanner && !specialRegister ?
                    <div className="item" style={{backgroundImage: `url(${firstImageBanner})`}}>
                        <div className="gen-movie-contain h-100">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-xl-6">
                                        <div className="gen-tag-line"><span></span></div>
                                        {/*<div className="gen-movie-info">*/}
                                        {/*    <ul>*/}
                                        {/*        <li></li>*/}
                                        {/*    </ul>*/}
                                        {/*    <h3>Descubre tu Propósito de Vida</h3>*/}
                                        {/*</div>*/}
                                        {/*<div className="gen-movie-meta-holder">*/}
                                        {/*    <p>Mi Propósito es una experiencia digital que te guía y acompaña para*/}
                                        {/*        descubrir lo que te impulsa: tu propósito de vida.</p>*/}
                                        {/*</div>*/}
                                        <div className="gen-movie-action">
                                            <div className="gen-btn-container button-1">
                                                <a href={specialRegister ? "https://www.wellbeing360.tv/category/semanadelbienestarintegral?specialRegister=true" : "https://www.wellbeing360.tv/category/semanadelbienestarintegral"}
                                                   className="gen-button">
                                                    <span className="text">
                                                        Explóralo ahora
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
                }
                {secondBanner && !specialRegister ?
                        <div className="item" style={{backgroundImage: `url(${secondImageBanner})`}}>
                        <div className="gen-movie-contain h-100">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-xl-6">
                                        <div className="gen-tag-line"><span>
                                            {/*Proximamente*/}
                                        </span></div>
                                        <div className="gen-movie-action">
                                            <div className="gen-btn-container button-1">
                                                <a href={specialRegister ? "category/semanadelbienestarintegral?specialRegister=true" : "category/semanadelbienestarintegral"}
                                                   className="gen-button">
                                                    <span className="text">
                                                        Explóralo ahora
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
                }
                {eventlang && !specialRegister ?
                    <div className="item" style={{backgroundImage: `url(${eventImageEsp})`}}>
                        <div className="gen-movie-contain h-100">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-xl-6">
                                        <div className="gen-tag-line"><span></span></div>
                                        <div className="gen-movie-info">
                                            <ul>
                                                <li></li>
                                            </ul>
                                            <h3>Descubre tu Propósito de Vida</h3>
                                        </div>
                                        <div className="gen-movie-meta-holder">
                                            <p>Mi Propósito es una experiencia digital que te guía y acompaña para
                                                descubrir lo que te impulsa: tu propósito de vida.</p>
                                        </div>
                                        <div className="gen-movie-action">
                                            <div className="gen-btn-container button-1">
                                                <a href={specialRegister ? 'https://miproposito.tecmilenio.com/?utm_source=ALIANZAS&utm_medium=Banner&utm_campaign=Wellbeing&specialRegister=true' : 'https://miproposito.tecmilenio.com/?utm_source=ALIANZAS&utm_medium=Banner&utm_campaign=Wellbeing'}
                                                   className="gen-button">
                                                    <span className="text">
                                                        Explóralo ahora
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
                }
                {event && !specialRegister ?
                    <div className="item" style={{backgroundImage: `url(${eventImage})`}}>
                        <div className="gen-movie-contain h-100">
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-xl-6">
                                        <div className="gen-tag-line"><span></span></div>

                                        <div className="gen-movie-action">
                                            <div className="gen-btn-container button-1">
                                                <a href={specialRegister ? 'https://www.wellbeing360.tv/live/index.html?specialRegister=true' : 'https://www.wellbeing360.tv/live/index.html'}
                                                   className="gen-buttonConMargin">
                                                    <span className="text">
                                                        <FormattedMessage
                                                            id="buttonLearnmore"
                                                            defaultMessage="Ver Ahora"
                                                        />
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> :
                    <></>
                }

                {otherSlides}
            </OwlCarousel>
        )
    }

    const SliderHeader = () => {
        if (header) {
            return (
                <div className="container space">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                        <h4 className="gen-heading-title text-uppercase">{category_name_for_show}</h4>
                    </div>
                </div>
            )
        } else {
            return (<></>)
        }
    }

    return (
        <section className={`pt-0 pb-0 ${!specialRegister ? 'mt-5' : ''}`}>
            <div>
                <SliderHeader/>
                <div className="container-fluid px-10">
                    <div className="row no-gutters">
                        <div className="col-12">
                            <div className="gen-banner-movies">
                                <Slider/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SliderFull;
